import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowUpRight, ShieldCheck, Check } from "lucide-react";
import { lender } from "../mock";
import { trackReferral } from "../utils/api";

// Standalone CTA button — tracks the click-through, then opens Sharon's Floify app.
export const ApplyWithSharon = ({ label = "Get Pre-Approved with Sharon", variant = "gold", className = "" }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    await trackReferral({ lender: lender.name, page: location.pathname });
    setLoading(false);
    window.open(lender.applyUrl, "_blank", "noopener,noreferrer");
  };

  const base =
    variant === "gold"
      ? "bg-[#d4af37] hover:bg-[#c19a2e] text-white"
      : "bg-white text-[#141210] hover:bg-[#f7edcf] border border-[#e0d6c5]";

  return (
    <Button
      onClick={handleClick}
      disabled={loading}
      className={`${base} rounded-full px-7 h-12 tracking-luxury uppercase text-xs ${className}`}
    >
      {label} <ArrowUpRight className="w-4 h-4 ml-2" />
    </Button>
  );
};

// Full lender feature card / section
export const LenderCard = ({ dark = false }) => {
  return (
    <div
      className={`rounded-3xl p-9 md:p-11 border ${
        dark
          ? "bg-[#141210] border-[#141210] text-[#e9dcc4]"
          : "bg-white border-[#efe6d6]"
      }`}
    >
      <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-center">
        <div className="md:col-span-3">
          <span className="inline-flex items-center gap-2 bg-[#d4af37] text-white text-[10px] tracking-luxury uppercase px-3 py-1.5 rounded-full mb-5">
            <ShieldCheck className="w-3 h-3" /> Kristy's Preferred Lender
          </span>
          <h3 className={`font-display text-3xl md:text-4xl mb-1 ${dark ? "text-[#f4ebd9]" : "text-[#141210]"}`}>
            {lender.name}
          </h3>
          <p className={`text-xs tracking-luxury uppercase mb-5 ${dark ? "text-[#c4b294]" : "text-gold"}`}>
            {lender.title}
          </p>
          <p className={`leading-relaxed mb-7 ${dark ? "text-[#cabb9f]" : "text-[#5c5348]"}`}>
            {lender.blurb}
          </p>
          <div className="grid grid-cols-2 gap-x-6 gap-y-3 mb-8">
            {lender.perks.map((p) => (
              <div key={p} className="flex items-center gap-2.5">
                <span className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${dark ? "bg-[#d4af37]" : "bg-[#f7edcf]"}`}>
                  <Check className={`w-3 h-3 ${dark ? "text-white" : "text-gold"}`} />
                </span>
                <span className={`text-sm ${dark ? "text-[#e9dcc4]" : "text-[#4a423a]"}`}>{p}</span>
              </div>
            ))}
          </div>
          <ApplyWithSharon />
        </div>
        <div className="md:col-span-2">
          <div className={`rounded-2xl p-7 text-center ${dark ? "bg-[#0e0c0a]" : "bg-[#f4f1ea]"}`}>
            <div className="w-20 h-20 mx-auto rounded-full bg-[#d4af37] flex items-center justify-center mb-4">
              <span className="font-display text-3xl text-white">SC</span>
            </div>
            <div className={`font-display text-2xl ${dark ? "text-[#f4ebd9]" : "text-[#141210]"}`}>
              Ready in minutes
            </div>
            <p className={`text-sm mt-2 leading-relaxed ${dark ? "text-[#a8967a]" : "text-[#6b6154]"}`}>
              Start a fast, secure online application. Your progress is saved to your referral from Kristy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
